<template>

<div>

	<!-- show loading indicator -->
	<loading-indicator :loading="isLoading"></loading-indicator>

	<template v-if="!isLoading">

		<!-- page-heading -->
		<page-heading :pageTitle="title"></page-heading>

		<div class="columns">

			<div class="col-main">

				<div class="box">

					<equipmentSectionHeader title="EQUIPMENT-SECTION_HEADER-EQUIPMENT" />

					<!-- MAIN ASSET -->
					<div class="control is-horizontal">
							
						<div class="control-label">
							<label-name labelKey="EQUIPMENT-UPLOAD_FILE"></label-name>
						</div>

						<div class="control">

							<vue-dropzone
								ref="vueDropzoneEquipment"
								id="vueDropzoneEquipment"
								url= "fileProcessing/upload?preset=equipment"
								:maxFiles="1"
								:thumbnailWidth="100"
								:thumbnailHeight="100"
								acceptedFiles= ".jpg,.jpeg,.png,.gif"
								dictDefaultMessage="<i class='fa fa-cloud-upload'></i>Produktbild hochladen"
								v-on:vdropzone-removed-file="dzRemoveFile"
								v-on:vdropzone-mounted="dzInit"
								v-on:vdropzone-success="dzSuccess">
							</vue-dropzone>

						</div>

					</div>

					<!-- ADDITIONAL ASSETS -->
					<div class="control is-horizontal">
							
						<div class="control-label">
							<label-name labelKey="EQUIPMENT-UPLOAD_ASSETS"></label-name>
						</div>

						<div class="control">

							<vue-dropzone
								ref="vueDropzoneAdditionalAssets"
								id="vueDropzoneAdditionalAssets"
								url= "fileProcessing/upload?preset=equipment"
								:maxFiles="10"
								:thumbnailWidth="85"
								:thumbnailHeight="85"
								acceptedFiles= ".jpg,.jpeg,.png,.gif"
								dictDefaultMessage="<i class='fa fa-cloud-upload'></i>Produktbild hochladen"
								v-on:vdropzone-removed-file="dzRemoveFileAdditionalAssets"
								v-on:vdropzone-mounted="dzInitAdditionalAssets"
								v-on:vdropzone-success="dzSuccessAdditionalAssets">
							</vue-dropzone>

						</div>

					</div>


					<form-input inputType="text" label="EQUIPMENT-EXTREF" inputSize="is-medium" v-model="equipment.extRef" :isReadOnly="false" :isHorizontal="true"></form-input>
					<form-input inputType="text" label="EQUIPMENT-NAME" inputSize="is-medium" v-model="equipment.name" :isHorizontal="true"></form-input>
					<form-input inputType="text" label="EQUIPMENT-PIECES_PER_PACKAGE" inputSize="is-medium" v-model="equipment.piecesPerPackage" :isHorizontal="true"></form-input>
					<form-input inputType="text" label="EQUIPMENT-PRICE_AEP" inputSize="is-medium" v-model="equipment.priceAEP" :isPointToComma="true" :isHorizontal="true"></form-input>

					<br />
					<equipmentSectionHeader title="EQUIPMENT-SECTION_HEADER-CATEGORY" />
					<div class="control is-horizontal">
						<div class="control-label">
							<label-name labelKey="EQUIPMENT-ONLINE_CATEGORY"></label-name>
						</div>
						<div class="control" style="max-width: 450px;">

							<multiselect v-if="onlineCategoriesReady"
								v-model="equipment.onlineCategory"
								selectedLabel="ausgewählt"
								selectLabel="Klick für Auswahl"
								deselectLabel="Klick für Entfernen"
								placeholder="Suche nach Kategorie ..."	
								label="name"
								:customLabel="customLabel"
								track-by="id"
								:allowEmpty="true"
								:preserve-search="true"
								:hide-selected="false"
								:options="onlineCategories"
								@select="onOnlineCategorySelect"
								class="onlineCategories">

								<div slot="noResult">
									Für diesen Suchbegriff wurden keine Kategorien gefunden ...
								</div>

							</multiselect>

						</div>
					</div>
					<form-input inputType="switch" label="EQUIPMENT-SHOW_IN_ONLINE_CATALOG" v-model="equipment.online" :isHorizontal="true"></form-input>
					<br>

					<div class="control is-horizontal">
						<div class="control-label">
							<label-name labelKey="EQUIPMENT-PRINT_CATEGORY"></label-name>
						</div>
						<div class="control" style="max-width: 450px;">

							<multiselect
								v-model="selectedCategory"
								selectedLabel="ausgewählt"
								selectLabel="Klick für Auswahl"
								deselectLabel="Klick für Entfernen"
								placeholder="Suche nach Kategorie ..."
								label="name"
								track-by="id"
								:allowEmpty="true"
								:options="categories"
								@select="onPrintCategorySelect">

								<div slot="noResult">
									Für diesen Suchbegriff wurden keine Kategorien gefunden ...
								</div>

							</multiselect>

							<div v-if="equipment.categories && equipment.categories.length > 0" class="selected-categories">
								<div v-for="(catLink, index) in equipment.categories" :key="index" class="category-item">
									<span v-if="catLink.category">{{ catLink.category.name }}</span>
									<span class="icon is-small has-cursor-pointer" @click="removeCategory(index)">
										<i class="fa fa-trash"></i>
									</span>
								</div>
							</div>

						</div>
					</div>
					<form-input inputType="switch" label="EQUIPMENT-SHOW_IN_PRINT_CATALOG" v-model="equipment.print" :isHorizontal="true"></form-input>

					<equipmentSectionHeader title="EQUIPMENT-SECTION_HEADER-ATTRIBUTES">
						<i class="fa fa-spinner fa-spin" v-if="isAttributesLoading"></i>
					</equipmentSectionHeader>

					<template v-for="(value, index) in equipmentData" v-if="equipmentData!=null">
						<form-input inputType="text" :label="'ECP-TBL_HEADER-'+value" inputSize="is-medium" v-model="equipment.data[value]" :isPointToComma="false" :isHorizontal="true" class="smallHeight">
							<template slot="button">
								<button class="button is-medium" @click="removeAttribute(value)" title="Attribut löschen">
									<span class="icon is-small">
										<i class="fa fa-trash"></i>
									</span>
								</button>
							</template>
						</form-input>
					</template>

	
					<form-input inputType="custom" label="EQUIPMENT-ADD_FURTHER_ATTRIBUTES" :isHorizontal="true">
						<multiselect
							v-model="selectedAvailableAttribute"
							:options="filteredAvailableAttributes"		
							track-by="name"
							:custom-label="attributeCustomLabel"
							select-label="Klick für Auswahl"
							deselect-label="Klick für Entfernen"
							selected-label="ausgewählt"
							placeholder="Suche nach Attribut ..."
							@select="addAttribute"
							:allowEmpty="true">
							<template slot="noResult">
								Für diesen Suchbegriff wurden keine Attribute gefunden ...
							</template>
						</multiselect>
					</form-input>
					<!--
					<form-input
						inputType="select"
						:selectOptions="groupByOptions"
						:showLabelInOptions="false"
						v-model="groupByValue"
						label="EQUIPMENT-GROUPBY"
						selectFieldName="name"
						selectCustomLabel="label"
						is-horizontal="true">
					</form-input>
					-->

					<form-input v-if="equipmentData != null" inputType="custom" label="EQUIPMENT-GROUPBY" :isHorizontal="true" style="margin-top: 20px;">
						<multiselect
							v-model="groupByValue"
							:options="groupByOptions"		
							track-by="name"
							:custom-label="attributeCustomLabel"
							select-label="Klick für Auswahl"
							deselect-label="Klick für Entfernen"
							selected-label="ausgewählt"
							placeholder="Suche nach Attribut ..."
							:allowEmpty="true">
							<template slot="noResult">
								Für diesen Suchbegriff wurden keine Attribute gefunden ...
							</template>
						</multiselect>
					</form-input>
			

					<equipmentSectionHeader title="EQUIPMENT-SECTION_HEADER-INFORMATION" />


					<!-- DESCRIPTION -->
					<div class="control is-horizontal">

						<div class="control-label">
							<label-name labelKey="EQUIPMENT-DESCRIPTION"></label-name>
						</div>

						<div class="control froalaPlain">
							<froala :tag="'textarea'" :config="froalaConfig" v-model="equipment.description"></froala>
						</div>

					</div>




					<br />

					<!-- isOrderable -->
					<div class="control is-horizontal">
						<div class="control-label">
							<label-name labelKey="EQUIPMENT-IS_ORDERABLE"></label-name>
						</div>
						<div class="control">
							<b-switch v-model="equipment.isOrderable" type="primary" size="small"></b-switch>
						</div>
					</div>

					<!-- isOffer -->
					<div class="control is-horizontal">
						<div class="control-label">
							<label-name labelKey="EQUIPMENT-IS_OFFER"></label-name>
						</div>
						<div class="control">
							<b-switch v-model="equipment.isOffer" type="primary" size="small"></b-switch>
						</div>
					</div>

					<!-- offerPrice -->
					<template v-if="equipment.isOffer">
						<form-input inputType="text" label="EQUIPMENT-OFFER_PRICE" inputSize="is-medium" v-model="equipment.offerPrice" :isReadOnly="false" :isHorizontal="true" :isPointToComma="true"></form-input>

						<div class="control is-horizontal">
							<div class="control-label">
								<label-name labelKey="EQUIPMENT-OFFER_START_DATE"></label-name>
							</div>
							<div class="control">
								<datepicker placeholder="Start-Datum wählen" :options="datePickerStartOptions" v-model="equipment.offerStartDate"></datepicker>
							</div>
						</div>

						<div class="control is-horizontal">
							<div class="control-label">
								<label-name labelKey="EQUIPMENT-OFFER_END_DATE"></label-name>
							</div>
							<div class="control">
								<datepicker placeholder="End-Datum wählen" :options="datePickerEndOptions" ref="datePickerEnd" v-model="equipment.offerEndDate"></datepicker>
							</div>
						</div>
						<br><br>

					</template>

					<!-- hide price -->
					<div class="control is-horizontal">
						<div class="control-label">
							<label-name labelKey="EQUIPMENT-HIDE_PRICE"></label-name>
						</div>
						<div class="control">
							<b-switch v-model="equipment.hidePrice" type="primary" size="small"></b-switch>
						</div>
					</div>

					<!-- not returnable -->
					<div class="control is-horizontal">
						<div class="control-label">
							<label-name labelKey="EQUIPMENT-NOT_RETURNABLE"></label-name>
						</div>
						<div class="control">
							<b-switch v-model="equipment.notReturnable" type="primary" size="small"></b-switch>
						</div>
					</div>



					<!-- CROSS SELLING -->
					<div class="control is-horizontal">

						<div class="control-label" style="align-self: flex-start;">
							<label-name labelKey="EQUIPMENT-LINKED_PRODUCTS"></label-name>
						</div>

						<div class="control">

							<div class="add-crosslink-wrapper" style="margin-bottom: 15px;">
								<multiselect
									v-model="selectedEquipmentLink"
									selectedLabel="ausgewählt"
									selectLabel="Klick für Auswahl"
									deselectLabel="Klick für Entfernen"
									placeholder="Suche nach Gerät zum Verknüpfen ..."
									label="name"
									:customLabel="customLabelCrossLink"
									track-by="id"
									:allowEmpty="true"
									:resetAfter="true"
									:hide-selected="true"
									:options="equipments"
									:optionsLimit="15"
									@select="onCrossLinkSelect">
									<div slot="noResult">Für diesen Suchbegriff wurden keine Geräte gefunden ...</div>
								</multiselect>
							</div>

							<template v-if="equipment.equipmentLinks.length > 0">

								<draggable
								v-model="equipment.equipmentLinks"
								:options="{
										animation: 200,
										handle: '.dragHandler',
										draggable: '.list-complete-item'
									}"
									@end="onDragComplete"
									class="crossLinks">

									<div v-for="(equipmentLink, index) in equipment.equipmentLinks" :key="equipmentLink" v-if="equipmentLink.linkedEquipment!=null" class="equipmentLinks list-complete-item">

										<div class="column">
											<figure class="image is-32x32">
												<img v-lazy="equipmentImageGet(equipmentLink.linkedEquipment.asset)" />
											</figure>
										</div>

										<div class="column"><strong>#{{ equipmentLink.linkedEquipment.extRef }}</strong><br />{{ equipmentLink.linkedEquipment.name }}</div>

										<div class="column">

											<span class="icon is-small dragHandler has-cursor-move">
												<!-- <i class="icon-ak-move"></i> -->
												<i class="fa fa-arrows"></i>
											</span>

											<pop-confirm class="icon is-small has-cursor-pointer" content="Soll dieses verlinkte Gerät wirklich entfernt werden?" icon="question-circle-o" cancel-text="nein" ok-text="ja" :on-ok="function() { equipmentLinkRemove(index) }">
												<!-- <i class="icon-ak-entfernen"></i> -->
												<i class="fa fa-trash"></i>
											</pop-confirm>

										</div>

									</div>

								</draggable>

							</template>

						</div>

					</div>
		
				</div>

			</div>

      <div class="col-aside">

		<affix :offset="50">

			<custom-button type="blue" icon="icon-ak-speichern" name="EQUIPMENT-BTN_SAVE" :loading="isSaving" @click.native="submitForm()" :class="{'is-disabled': isReadOnly}"></custom-button>
			<template v-if="!isNewEquipment">
				<custom-button type="dark" icon="icon-ak-entfernen" name="EQUIPMENT-BTN-DELETE" @click.native="deleteEquipment()" :class="{'is-disabled': isReadOnly}"></custom-button>
			</template>

		</affix>

      </div>

    </div>



	</template>

</div>
</template>



<script>
import comments from '../utils/incl-comments';
import vue2Dropzone from '../utils/dropzoneWrapper'
import draggable from 'vuedraggable';
import Multiselect from 'vue-multiselect'
import EquipmentSectionHeader from './equipmentSectionHeader.vue'

// Require Froala Editor js and css files
require('froala-editor/js/froala_editor.pkgd.min')
require('froala-editor/js/languages/de.js')
require('froala-editor/css/froala_editor.pkgd.min.css')
require('froala-editor/css/froala_style.min.css')

import Vue from 'vue';
import VueFroala from 'vue-froala-wysiwyg';
Vue.use(VueFroala)

import { de } from 'flatpickr/dist/l10n/de';

export default {

  name: 'equipment',

	components: {
		vueDropzone: vue2Dropzone,
		comments,
		draggable,
		Multiselect,
		VueFroala,
		EquipmentSectionHeader
	},

	data() {
		var self = this;
		return {
			equipment: null,
			equipmentData: [],
			equipments: [],
			groupByOptions: [],
			groupByValue: null,
			onlineCategories: [],
			onlineCategoriesReady: false,
			categories: [],
			selectedCategory: null,
			selectedAvailableAttribute: null,
			selectedEquipmentLink: null,
			equipmentCategories: null,
			isNewEquipment: false,
			isSaving: false,
			isLoading: false,
			isAttributesLoading: false,
			showModal: false,
			modalTitle: "",
			availableAttributes: [],
			froalaConfig: {
				key: '',
				toolbarButtons: ['bold', 'italic', 'underline', '|', 'paragraphStyle', '|', 'subscript', 'superscript', '|', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', '|', 'insertTable', '|', 'insertImage', 'insertFile', 'insertLink', '|', 'undo', 'redo'],
				paragraphMultipleStyles: false,
				imageManagerLoadURL: '',
				imageUploadURL: '',
				imageUploadParams: { froala: 1 },
				imageInsertButtons: ['imageUpload'],
				imageDefaultWidth: 150,
				imageDefaultAlign: 'left',
				fileUploadURL: '',
				fileUploadParams: { froala: 1 },
				paragraphStyles: {
					'fr-text-headline': 'Überschrift',
					'fr-text-teaser': 'Text größer',
					'fr-text-annotation': 'Anmerkung'
				},
				requestHeaders: {
					"Authorization": 'Basic ' + localStorage.getItem('token')
			  },
			heightMin: 200,
			quickInsertButtons: ['image', 'table', 'ul', 'ol'],
			language: 'de',
			tableEditButtons: ['tableHeader', 'tableRemove', '|', 'tableRows', 'tableColumns', '-', 'tableCells', 'tableCellVerticalAlign', 'tableCellHorizontalAlign'],
			tableMultipleStyles: false,
			placeholderText: 'Schreiben Sie hier Ihren Text ...',
			charCounterCount: false,
			pastePlain: true,
			initOnClick: false,
			quickInsertButtons: [],
			quickInsertTags: [],        // disable quickInsertBar
			language: 'de',
    	},

		datePickerStartOptions: {
        wrap: false,
        enableTime: false,
        altInput: true,
        altFormat: 'd.m.Y',
        locale: de,
		clickOpens: true,
        weekNumbers: true,
		minDate: null,
		maxDate: null,
        onClose(selectedDates, dateStr, instance) {
					self.$set(self.datePickerEndOptions, 'minDate', dateStr);
        }
      },

	datePickerEndOptions: {
        enableTime: false,
        altInput: true,
        altFormat: 'd.m.Y',
        locale: de,
		clickOpens: true,
        weekNumbers: true,
		minDate: null,
		maxDate: null,
		onOpen(selectedDates, dateStr, instance) {
        },
      },

		}
	},

	computed: {

		title() {

			if(this.isNewEquipment == true) {
				return 'HEADER-NEW_EQUIPMENT';
			} else {
				return this.equipment.name;
			}
		},

		filteredAvailableAttributes() {
			if (!this.availableAttributes) return [];

			const forbiddenAttributes = ["extRef", "name", "piecesPerPackage", "priceAEP"];
			
			return this.availableAttributes.filter(attr => {
				const attrName = typeof attr === 'string' ? attr : attr.name;
				
				// Check if it's a forbidden attribute
				if (forbiddenAttributes.some(f => f.toLowerCase() === attrName.toLowerCase())) {
					return false;
				}

				// Check if it's already in equipmentData (UI) or data (values) - case-insensitive
				const existsInData = this.equipment && this.equipment.data ? Object.keys(this.equipment.data).some(k => k.toLowerCase() === attrName.toLowerCase()) : false;
				const existsInList = (this.equipmentData || []).some(k => k.toLowerCase() === attrName.toLowerCase());
				
				return !existsInData && !existsInList;
			});
		}

	},

	created() {

		// set licence key for froala
		this.froalaConfig.key = this.$config.froalaKey;

		this.axios.all([this.fetchOnlineCategories(), this.fetchAttributes(), this.fetchCategories()]);

		// fetch cross-selling options early and non-blocking
		this.fetchCrossSellingEquipment();

		// existing product - fetch the equipment ID from router
		if(this.$route.params.equipmentID && Number.isInteger(parseInt(this.$route.params.equipmentID)) ) {
			this.fetchData();
		}

		// new product
		else
		{
			this.isNewEquipment = true;

			// create new equipment obj with default values
			this.equipment = {
		   		name: "",
				equipmentLinks: [],
				assets: [],
				categories: [],
				showInOnlineCatalog: false,
				showInPrintCatalog: false
			}

		}

		// set froala image upload url
		this.froalaConfig.imageUploadURL = this.$config.api + 'fileProcessing/upload?preset=equipmentCatalogPageElement&froala=1';
		this.froalaConfig.fileUploadURL = this.$config.api + 'fileProcessing/upload?preset=equipmentCatalogPageElement&froala=1';
	},

	mounted() {

	},

	update() {

	},

	methods: {

		customLabel({ parent, name }) {

			if(parent != null && parent.parent != null) {
				return parent.parent.name + ' > ' + parent.name + ' > ' + name;
			} else {
				return "Suchen ...";
			}

		},

		customLabelCrossLink({ name, extRef }) {

			return '#'+extRef + ' - ' + name;

		},


		deleteEquipment() {

			var self = this;
			this.entityDelete('equipment', this.$route.params.equipmentID, 'EQUIPMENTS-MSG-CONFIRM_DELETION').then(function(response) {
				self.$router.push({ name: 'equipments'} );
			})

		},

		getEquipmentLabel(index) {

			if(index == 0) {
				return 'EQUIPMENT-CATEGORY';
			}

		},


		equipmentLinkRemove(index) {

			this.equipment.equipmentLinks.splice(index, 1);
			this.equipmentLinksSort();

		},

		onCrossLinkSelect(selectedOption) {
			
			if(!selectedOption) return;

			let newCrossLink = {
				equipment: this.equipment.id,
				linkedEquipment: selectedOption,
				sortorder: this.equipment.equipmentLinks.length + 1
			}

			this.equipment.equipmentLinks.push(newCrossLink);

			this.$nextTick(() => {
				this.selectedEquipmentLink = null;
			});
		},

		onPrintCategorySelect(selectedOption) {

			if (!this.equipment.categories) {
				this.$set(this.equipment, 'categories', []);
			}
			
			// check if already added
			const exists = this.equipment.categories.some(c => c.category && c.category.id === selectedOption.id);
			if (exists) {
				this.$notify.open({ content: 'Diese Kategorie wurde bereits hinzugefügt!', type: 'warning'});
				this.selectedCategory = null;
				return;
			}

			this.equipment.categories.push({
				category: selectedOption,
				equipment: this.equipment.id,
				sortorder: this.equipment.categories.length + 1
			});

			if (selectedOption.columns) {
				this.appendAttributesFromColumns(selectedOption.columns);
			}
			
			this.$nextTick(() => {
				this.selectedCategory = null;
			});
		},

		async onOnlineCategorySelect(selectedOption) {

			if(!selectedOption) return;

			this.isAttributesLoading = true;

			try {
				const res = await this.axios.get(this.$config.api+`equipmentOnlineCategory/${selectedOption.id}/attributes`);

				if (res.data && Array.isArray(res.data)) {
					const attributes = res.data.map(attr => attr.name).join(',');
					this.appendAttributesFromColumns(attributes);
				}
			} finally {
				this.isAttributesLoading = false;
			}
		},

		removeCategory(index) {
			this.equipment.categories.splice(index, 1);
			this.resortCategories();
		},

		resortCategories() {
			this.equipment.categories.forEach((cat, index) => {
				cat.sortorder = index + 1;
			});
		},


		onDragComplete() {

			this.equipmentLinksSort();
		},

		equipmentLinksSort() {

			this.equipment.equipmentLinks.forEach(function(equipment, index) {
				equipment.sortorder = index;
			});

		},

		// dropzone handling
		// ---------------------------------------------------------------------
		dzInit() {


			if(this.equipment.asset && this.equipment.asset != null && this.equipment.asset.filename != null) {

				var url = this.$config.assets + this.equipment.asset.path + '/' + this.equipment.asset.filename;
				var mockFile = { id: 'eqImage', name: this.equipment.asset.filename, type: "image/*", size: 123 }

				// add mockFile to our dropzone
				this.$refs.vueDropzoneEquipment.$children[0].manuallyAddFile(mockFile, url);

			}

		},

		dzInitAdditionalAssets() {

			if (this.equipment.assets && Array.isArray(this.equipment.assets)) {

				this.equipment.assets.forEach(item => {

					if (item.asset && item.asset.filename) {
						var url = this.$config.assets + item.asset.path + '/' + item.asset.filename;
						var mockFile = { id: item.asset.id, name: item.asset.filename, type: "image/*", size: 123 }

						// add mockFile to our dropzone
						this.$refs.vueDropzoneAdditionalAssets.$children[0].manuallyAddFile(mockFile, url);
					}

				});

			}

		},

		dzSuccessAdditionalAssets(file) {

			var result = JSON.parse(file.xhr.response);

			if (!this.equipment.assets) {
				this.$set(this.equipment, 'assets', []);
			}

			this.equipment.assets.push({
				asset: {
					filename: result.fileName,
					path: result.dir,
					uploadFilename: file.name
				}
			})

		},

		dzRemoveFileAdditionalAssets(file) {

			this.equipment.assets = this.equipment.assets.filter(item => {
				if (item.asset) {
					return item.asset.filename !== file.name && item.asset.uploadFilename !== file.name;
				}
				return true;
			});

		},


		dzSuccess(file) {

			var result = JSON.parse(file.xhr.response);

			this.equipment.asset = {
				filename: result.fileName,
				path: result.dir,
				uploadFilename: file.name
			}

		},

		dzRemoveFile() {

			this.equipment.asset = null;

		},

		fetchData() {

			this.isLoading = true;
			var self = this;

			// get categories
			function getEquipmentCategories() {
				return self.axios.get(self.$config.api + 'equipmentCategory?orderBy=name');
			}

			// get equipment
			function getEquipment() {
				return self.axios.get(self.$config.api + 'equipment/' + self.$route.params.equipmentID + '?include=equipment.onlineCategory,equipmentOnlineCategory.parent,equipment.categories,equipmentCategoryEquipment.category,equipment.asset,equipment.equipmentLinks,equipmentLink.linkedEquipment,equipment.categories,equipmentCategoryEquipment.category,equipment.assets,equipmentAsset.asset')
			}


			// make the request
			this.axios.all([getEquipment(), getEquipmentCategories()])

				.then(self.axios.spread(function (equipment, equipmentCategories) {

					self.equipment = equipment.data;

					if (!self.equipment.assets) {
						self.$set(self.equipment, 'assets', []);
					}

					self.equipmentCategories = equipmentCategories.data.equipmentCategory;

					if(self.equipment.onlineCatalogGroupBy != null) {

						self.groupByValue = {
							id: null,
							// label: self.$t('ECP-TBL_HEADER-'+self.equipment.onlineCatalogGroupBy.toUpperCase()),
							customLabel: self.$t('ECP-TBL_HEADER-'+self.equipment.onlineCatalogGroupBy.trim().toUpperCase()),
							name: self.equipment.onlineCatalogGroupBy
						}

					}

					if(equipment.data.data != null) {

						const forbiddenAttributes = ["extRef", "name", "piecesPerPackage", "priceAEP"];
						let k, i=0;
						for (k of Object.keys(equipment.data.data)) {

							const isForbidden = forbiddenAttributes.some(f => f.toLowerCase() === k.toLowerCase());
							if (isForbidden) continue;

							self.equipmentData.push(k);
							self.groupByOptions.push({
								id: null,
								label: self.$t('ECP-TBL_HEADER-'+k.trim().toUpperCase()),
								name: k
							});
						}

						// add "piecesPerPackage" to selectbox
						self.groupByOptions.push({
							id: self.groupByOptions.length,
							label: self.$t('ECP-TBL_HEADER-PIECESPERPACKAGE'),
							name: 'piecesPerPackage'
						})

					}

					self.isLoading = false;

				}));

		},

		fetchCategories() {

			return this.axios.get(this.$config.api + 'equipmentCategory?orderBy=name&filters[name]=!&filters[pageIndex]=!NULL ')
				.then((res) => {
					this.categories = res.data.equipmentCategory;
			});

		},


		fetchOnlineCategories() {

			this.onlineCategoriesReady = false;
			return this.axios.get(this.$config.api + 'equipmentOnlineCategory?include=equipmentOnlineCategory.parent&filters[level]=2')
				.then((res) => {
					this.onlineCategories = res.data.equipmentOnlineCategory;
					this.onlineCategoriesReady = true;
			});

		},

		fetchAttributes() {

			return this.axios.get(this.$config.api + 'equipmentCategory/attributes')
				.then((res) => {
					this.availableAttributes = res.data;
				});

		},

		fetchCrossSellingEquipment() {

			var self = this;
			const currentId = this.$route.params.equipmentID || (this.equipment ? this.equipment.id : null);
			const idFilter = currentId ? '&filters[id]=!' + currentId : '';

			this.axios.get(this.$config.api + 'equipment?include=equipment.categories,equipmentCategoryEquipment.category,equipment.asset,equipment.onlineCategory' + idFilter)
				.then(function(response) {
					self.equipments = response.data.equipment;
			});

		},

		submitForm() {

			var self = this;

			this.equipment.onlineCatalogGroupBy = null;

			if(this.groupByValue && this.groupByValue.name != null) {
				this.equipment.onlineCatalogGroupBy = this.groupByValue.name;
			}

			this.entityCreateOrUpdate('equipment', this.equipment, 'ECP-MSG-PAGE_SUCCESSFULLY_SAVED')
				.then(function(response) {
					self.equipment.id = response.id;
				});

		},


		equipmentImageGet(asset) {

			if(asset != null) {
				return this.$config.assets + asset.path + '/thumb/' + asset.filename;
			}

			return "";

		},

		updateEquipmentDataFromColumns(columns) {

			if (!columns) return;

			const forbiddenAttributes = ["extRef", "name", "piecesPerPackage", "priceAEP"];
			const columnList = columns.split(',').map(s => s.trim()).filter(s => s !== '');

			// Case-insensitive deduplication and filtering
			const uniqueColumns = [];
			columnList.forEach(col => {
				const isForbidden = forbiddenAttributes.some(f => f.toLowerCase() === col.toLowerCase());
				const isDuplicate = uniqueColumns.some(u => u.toLowerCase() === col.toLowerCase());

				if (!isForbidden && !isDuplicate) {
					uniqueColumns.push(col);
				}
			});

			this.equipmentData = uniqueColumns;

			if (!this.equipment.data) {
				this.$set(this.equipment, 'data', {});
			}

			this.updateGroupByOptions();
		},

		appendAttributesFromColumns(columns) {

			if (!columns) return;

			const forbiddenAttributes = ["extRef", "name", "piecesPerPackage", "priceAEP"];
			const columnList = columns.split(',').map(s => s.trim()).filter(s => s !== '');

			if (!this.equipment.data) {
				this.$set(this.equipment, 'data', {});
			}

			columnList.forEach(col => {
				// Check against forbidden attributes
				const isForbidden = forbiddenAttributes.some(f => f.toLowerCase() === col.toLowerCase());
				if (isForbidden) return;

				// Check against equipmentData (current list) AND data (existing values) - case-insensitive
				const existsInData = Object.keys(this.equipment.data).some(k => k.toLowerCase() === col.toLowerCase());
				const existsInList = this.equipmentData.some(k => k.toLowerCase() === col.toLowerCase());

				if (!existsInData && !existsInList) {
					this.equipmentData.push(col);
				}
			});

			this.updateGroupByOptions();
		},

		removeAttribute(attrName) {

			const index = this.equipmentData.indexOf(attrName);
			if (index > -1) {
				this.equipmentData.splice(index, 1);
			}

			if (this.equipment.data[attrName] !== undefined) {
				this.$delete(this.equipment.data, attrName);
			}

			this.updateGroupByOptions();

		},

		addAttribute(selectedAttribute) {

			const attr = selectedAttribute || this.selectedAvailableAttribute;

			if (attr) {
				const attrName = typeof attr === 'string' ? attr : attr.name;
				this.appendAttributesFromColumns(attrName);
				
				this.$nextTick(() => {
					this.selectedAvailableAttribute = null;
				});
			}

		},

		attributeCustomLabel(attr) {
			const attrName = typeof attr === 'string' ? attr : attr.name;
			return this.$t('ECP-TBL_HEADER-' + attrName.trim().toUpperCase()) + ' (' + attr.name + ')';
		},

		updateGroupByOptions() {
			
			// Ensure groupByOptions is also updated
			this.groupByOptions = [];
			this.equipmentData.forEach((k) => {

				if (this.equipment.data[k] === undefined) {
					this.$set(this.equipment.data, k, '');
				}

				this.groupByOptions.push({
					id: null,
					label: this.$t('ECP-TBL_HEADER-' + k.trim().toUpperCase()),
					name: k
				});
			});

			// add "piecesPerPackage" to selectbox
			this.groupByOptions.push({
				id: this.groupByOptions.length,
				label: this.$t('ECP-TBL_HEADER-PIECESPERPACKAGE'),
				name: 'piecesPerPackage'
			});
		},

	}

}

</script>



<style lang="scss" scoped>

	.smallHeight {

		.textarea {
			height: 20px;
	    	min-height: 55px;
		}
	}

	.selected-categories {
		margin-top: 10px;
		display: flex;
		flex-wrap: wrap;
		gap: 5px;
	}

	.category-item {
		background: #fafafa;
		width: 100%;
		display: flex;
		align-items: center;
		margin-bottom: 2px;
		border-radius: 3px;
		padding: 10px;


		.icon {
			margin-left: auto;
			flex-shrink: 0;
			&:hover {
				color: #bd081c;
			}
			
		}
	}

	.crossLinks {
		width: 100%;
	}

	.crossLinks {
		width: 100%;
	}

	.equipmentModal {

		::v-deep .modal-card {

			overflow: visible;
			min-height: 100px;

			.modal-card-body {
				z-index: 10;
				overflow: visible;
			}

			.multiselect__content-wrapper {
				overflow-x: hidden;
			}
		}

	}

	.equipmentLinks {

		background: #fafafa;
		width: 100%;
		display: flex;
		margin-bottom: 2px;
		border-radius: 3px;

		.column {

			&:not(:nth-child(2)) {
				display: flex;
				align-items: center;
				flex-grow: 1;
				padding: 5px;
				font-size: 12px;
			}
			&:nth-child(2) strong {
				font-size: 10px;
			}

			&:first-child,
			&:last-child {
				flex-grow: 0;
			}

			span {

				&.icon {
					background: #eee;
					height: 22px;
					width: 22px;
					line-height: 22px;
					font-size: 13px;
					padding: 0;
					border-radius: 3px;

					&:not(:last-child) {
						margin-right: 5px;
					}

					i.fa-trash {

						&:hover {
							color: #bd081c;
						}
					}
				}

			}

		}
	}

</style>

<style scoped>
	/*
	.onlineCategories ::v-deep .multiselect__content-wrapper {
		overflow: hidden;
	}
		*/
	::v-deep .fr-box {
		width: 100%;
	}
	::v-deep .fr-element a {
		text-decoration: underline !important;
	}
</style>
